// ============================================================
// CONFIGURATEUR DE VERRES — OptikAnge
// ============================================================

const SPHERES = [];
for (let i = -20; i <= 20; i += 0.25) SPHERES.push(i.toFixed(2));
const CYLINDRES = [];
for (let i = -6; i <= 6; i += 0.25) CYLINDRES.push(i.toFixed(2));
const AXES = [];
for (let i = 0; i <= 180; i += 5) AXES.push(i + '°');
const ADDITIONS = [];
for (let i = 0.75; i <= 3.5; i += 0.25) ADDITIONS.push('+' + i.toFixed(2));
const ECARTS = [];
for (let i = 24; i <= 40; i += 0.5) ECARTS.push(i.toFixed(1));
const DP_VALUES = [];
for (let i = 48; i <= 80; i += 0.5) DP_VALUES.push(i.toFixed(1));

window.CFG = {
  correctionType: null,
  verreType: null,
  sphereOD: '0.00', sphereOG: '0.00',
  cylindreOD: '0.00', cylindreOG: '0.00',
  axeOD: '0°', axeOG: '0°',
  additionOD: '', additionOG: '',
  ecartOD: '', ecartOG: '',
  dpTotal: '',
  ordoFile: null,
  typeVerre: null,
  amincissement: null,
  options: {},
  totalExtras: 0
};

document.addEventListener('DOMContentLoaded', function () {
  populateSelects();
  bindStep1();
  showStep(1);
});

function populateSelects() {
  fillSelect('sphere-od', SPHERES, '0.00');
  fillSelect('sphere-og', SPHERES, '0.00');
  fillSelect('cylindre-od', CYLINDRES, '0.00');
  fillSelect('cylindre-og', CYLINDRES, '0.00');
  fillSelect('axe-od', AXES, '0°');
  fillSelect('axe-og', AXES, '0°');
  fillSelect('addition-od', ADDITIONS, '');
  fillSelect('addition-og', ADDITIONS, '');
  fillSelect('ep-od', ECARTS, '');
  fillSelect('ep-og', ECARTS, '');
  fillSelect('dp-total', DP_VALUES, '');
  fillSelect('dp-total-upload', DP_VALUES, '');
}

function fillSelect(id, values, defaultVal) {
  const sel = document.getElementById(id);
  if (!sel) return;
  sel.innerHTML = '<option value="">—</option>';
  values.forEach(v => {
    const opt = document.createElement('option');
    opt.value = v;
    opt.textContent = v;
    if (v === defaultVal) opt.selected = true;
    sel.appendChild(opt);
  });
}

function bindStep1() {
  document.querySelectorAll('input[name="correction-type"]').forEach(radio => {
    radio.addEventListener('change', function () {
      CFG.correctionType = this.value;
      document.querySelectorAll('.cfg-choice').forEach(c => c.classList.remove('selected'));
      this.closest('.cfg-choice').classList.add('selected');
      document.getElementById('cfg-manual-section').style.display = this.value === 'manual' ? 'block' : 'none';
      document.getElementById('cfg-upload-section').style.display = this.value === 'upload' ? 'block' : 'none';
      document.getElementById('cfg-ordonnance-fields').style.display = 'none';
      if (this.value === 'none') {
        document.getElementById('btn-step1-next').disabled = false;
        document.getElementById('btn-step1-next').textContent = 'CONTINUER →';
      } else {
        checkStep1Valid();
      }
    });
  });

  document.querySelectorAll('input[name="verre-type"]').forEach(radio => {
    radio.addEventListener('change', function () {
      CFG.verreType = this.value;
      document.querySelectorAll('.cfg-verre-opt').forEach(o => o.classList.remove('selected'));
      this.closest('.cfg-verre-opt').classList.add('selected');
      const fields = document.getElementById('cfg-ordonnance-fields');
      if (fields) fields.style.display = 'block';
      const isProgressif = this.value === 'progressif';
      const addRow = document.getElementById('addition-row');
      if (addRow) addRow.style.display = isProgressif ? 'table-row' : 'none';
      checkStep1Valid();
    });
  });

  const fileInput = document.getElementById('ordo-file');
  if (fileInput) {
    fileInput.addEventListener('change', function () {
      CFG.ordoFile = this.files[0];
      document.getElementById('upload-label').textContent = CFG.ordoFile ? '✓ ' + CFG.ordoFile.name : 'Glissez votre ordonnance ici';
      checkStep1Valid();
    });
  }

  ['sphere-od','sphere-og','cylindre-od','cylindre-og','dp-total'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.addEventListener('change', function() { checkStep1Valid(); updateRecap(); });
  });

  ['ep-od', 'ep-og'].forEach(function(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('change', function() {
      var od = parseFloat(document.getElementById('ep-od').value) || 0;
      var og = parseFloat(document.getElementById('ep-og').value) || 0;
      if (od && og) {
        var total = (od + og).toFixed(1);
        var dpSel = document.getElementById('dp-total');
        if (dpSel) {
          var best = null, bestDiff = Infinity;
          Array.from(dpSel.options).forEach(function(opt) {
            var diff = Math.abs(parseFloat(opt.value) - parseFloat(total));
            if (diff < bestDiff) { bestDiff = diff; best = opt.value; }
          });
          if (best) dpSel.value = best;
        }
      }
      checkStep1Valid();
      updateRecap();
    });
  });

  window.addEventListener('dp:calculated', function(e) {
    const { od, og, total } = e.detail;
    selectClosest('ep-od', od);
    selectClosest('ep-og', og);
    selectClosest('dp-total', total);
    selectClosest('dp-total-upload', total);
    CFG.ecartOD = od; CFG.ecartOG = og; CFG.dpTotal = total;
    checkStep1Valid();
  });
}

function selectClosest(selectId, val) {
  const sel = document.getElementById(selectId);
  if (!sel) return;
  let best = null, bestDiff = Infinity;
  Array.from(sel.options).forEach(opt => {
    const diff = Math.abs(parseFloat(opt.value) - val);
    if (diff < bestDiff) { bestDiff = diff; best = opt.value; }
  });
  if (best) sel.value = best;
}

function checkStep1Valid() {
  const btn = document.getElementById('btn-step1-next');
  if (!btn) return;

  if (CFG.correctionType === 'none') {
    btn.disabled = false;
    return;
  }

  if (CFG.correctionType === 'upload') {
    var dp = document.getElementById('dp-total-upload')?.value || '';
    btn.disabled = !CFG.ordoFile || !dp;
    return;
  }

  if (CFG.correctionType === 'manual') {
    if (!CFG.verreType) { btn.disabled = true; return; }
    var sphereOD = document.getElementById('sphere-od')?.value || '';
    var sphereOG = document.getElementById('sphere-og')?.value || '';
    var epOD = document.getElementById('ep-od')?.value || '';
    var epOG = document.getElementById('ep-og')?.value || '';
    var dpTotal = document.getElementById('dp-total')?.value || '';
    btn.disabled = !sphereOD || !sphereOG || !epOD || !epOG || !dpTotal;
    return;
  }

  btn.disabled = true;
}

function cfgStep1Next() {
  if (CFG.correctionType === 'manual') {
    CFG.sphereOD = document.getElementById('sphere-od')?.value || '0.00';
    CFG.sphereOG = document.getElementById('sphere-og')?.value || '0.00';
    CFG.cylindreOD = document.getElementById('cylindre-od')?.value || '0.00';
    CFG.cylindreOG = document.getElementById('cylindre-og')?.value || '0.00';
    CFG.axeOD = document.getElementById('axe-od')?.value || '0°';
    CFG.axeOG = document.getElementById('axe-og')?.value || '0°';
    CFG.additionOD = document.getElementById('addition-od')?.value || '';
    CFG.additionOG = document.getElementById('addition-og')?.value || '';
    CFG.ecartOD = document.getElementById('ep-od')?.value || '';
    CFG.ecartOG = document.getElementById('ep-og')?.value || '';
    CFG.dpTotal = document.getElementById('dp-total')?.value || '';
  }
  updateRecap();
  renderTypeVerre();
  showStep(2);
  document.getElementById('btn-step2-next').disabled = !CFG.typeVerre;
}

function showStep(n) {
  document.querySelectorAll('.cfg-step').forEach(s => s.classList.remove('active'));
  const step = document.getElementById('cfg-step-' + n);
  if (step) step.classList.add('active');
  const labels = ['', 'ÉTAPE 1/5', 'ÉTAPE 2/5', 'ÉTAPE 3/5', 'ÉTAPE 4/5', 'ÉTAPE 5/5'];
  const progresses = ['', '20%', '40%', '60%', '80%', '100%'];
  document.getElementById('cfg-step-label').textContent = labels[n] || '';
  document.getElementById('cfg-progress-bar').style.width = progresses[n] || '0%';

  var sidebarRecap = document.getElementById('cfg-sidebar-recap');
  if (sidebarRecap) sidebarRecap.style.display = n === 5 ? 'none' : 'block';

  window.scrollTo(0, 0);
}

function updateRecap() {
  const lines = document.getElementById('cfg-recap-lines');
  if (!lines) return;
  let html = '';
  if (CFG.correctionType === 'none') {
    html += recapLine('Correction', 'Sans correction', 'Inclus');
  } else if (CFG.correctionType === 'manual' && CFG.verreType) {
    const label = CFG.verreType === 'progressif' ? 'Verres progressifs' : 'Verres standards';
    html += recapLine('Correction', 'Corrections manuellement', label);
  } else if (CFG.correctionType === 'upload') {
    html += recapLine('Correction', 'Ordonnance téléchargée', '');
  }
  if (CFG.typeVerre && TYPES_VERRE[CFG.typeVerre]) {
    html += recapLine('Type de verre', TYPES_VERRE[CFG.typeVerre].label, TYPES_VERRE[CFG.typeVerre].price);
  }
  if (CFG.amincissement && AMINCISSEMENTS[CFG.amincissement]) {
    html += recapLine('Amincissement', AMINCISSEMENTS[CFG.amincissement].label, AMINCISSEMENTS[CFG.amincissement].price);
  }
  if (CFG.options && Object.keys(CFG.options).some(k => CFG.options[k] && !k.endsWith('-sub') && !k.endsWith('-cat'))) {
    var optsLines = [];
    Object.keys(CFG.options).forEach(function(k) {
      if (CFG.options[k] && !k.endsWith('-sub') && !k.endsWith('-cat') && !k.endsWith('-couleur')) {
        var subKey = k + '-sub';
        var catKey = k + '-cat';
        var detail = k;
        if (CFG.options[subKey]) detail += ' | ' + CFG.options[subKey];
        if (CFG.options[catKey]) detail += ' | ' + CFG.options[catKey];
        optsLines.push(detail);
      }
    });
    if (optsLines.length) html += recapLine('Options', optsLines.join('<br>'), '');
  }
  lines.innerHTML = html;
}

function recapLine(category, detail, price) {
  return '<div class="cfg-recap-line"><div class="cfg-recap-line__left"><strong>' + category + '</strong>' + detail + '</div><div class="cfg-recap-line__price">' + price + '</div></div>';
}

const origDpValidate = window.dpValidate;
window.dpValidate = function() {
  if (origDpValidate) origDpValidate();
  const od = parseInt(document.getElementById('dp-od')?.value) || 0;
  const og = parseInt(document.getElementById('dp-og')?.value) || 0;
  if (od && og) {
    window.dispatchEvent(new CustomEvent('dp:calculated', { detail: { od, og, total: od + og } }));
  }
};

// ============================================================
// DONNÉES
// ============================================================

const TYPES_VERRE = {
  transparent: { label: 'Verres transparents', sub: 'Verres extra-durcis et antireflet', price: '+39,00 €', priceProgressif: '+99,00 €' },
  solaire:     { label: 'Verres solaires',      sub: 'Verres avec teinte — Protection totale contre rayons UV', price: '+49,00 €', priceProgressif: '+99,00 €' },
  adaptatif:   { label: 'Verres adaptatifs',    sub: 'Verres photochromatiques qui se teintent au soleil', price: '+109,00 €', priceProgressif: '+169,00 €' }
};

const AMINCISSEMENTS = {
  '1.5':  { label: 'Verres standards — Indice 1,5',   sub: 'Pour les corrections entre 0 et +/- 2',    price: 'Inclus' },
  '1.6':  { label: 'Verres amincis — Indice 1,6',     sub: 'Pour les corrections entre +/- 2 et 4',    price: '+59,00 €' },
  '1.67': { label: 'Verres très amincis — Indice 1,67', sub: 'Pour les corrections supérieures à +/- 4', price: '+129,00 €', recommande: true }
};;

const MIROIR_COULEURS = [
  { id: 'aube',       label: 'Aube',       g1: '#c8e63c', g2: '#e8a830' },
  { id: 'crepuscule', label: 'Crépuscule', g1: '#c8c060', g2: '#808040' },
  { id: 'feu',        label: 'Feu',        g1: '#f06020', g2: '#c82000' },
  { id: 'lagon',      label: 'Lagon',      g1: '#1060d0', g2: '#062880' },
  { id: 'metal',      label: 'Métal',      g1: '#6080a0', g2: '#203040' },
  { id: 'meteore',    label: 'Météore',    g1: '#909090', g2: '#404040' },
  { id: 'ocean',      label: 'Océan',      g1: '#20c090', g2: '#008050' },
  { id: 'olympe',     label: 'Olympe',     g1: '#8090c0', g2: '#405080' },
  { id: 'sirius',     label: 'Sirius',     g1: '#c060c0', g2: '#602080' },
  { id: 'titane',     label: 'Titane',     g1: '#a0a0a0', g2: '#505050' }
];

const TEINTES_DATA = {
  'uni-classique': {
    label: 'Teinte unie classique',
    couleurs: [
      { id: 'brun', label: 'Brun', hex: '#6B3A2A', categories: [
        { id: 'brun-ab', label: 'Brun AB', cat: 'Catégorie 1', pct: 35 },
        { id: 'brun-b', label: 'Brun B', cat: 'Catégorie 2', pct: 55 },
        { id: 'brun-c', label: 'Brun C', cat: 'Catégorie 3', pct: 85 }
      ]},
      { id: 'gris', label: 'Gris', hex: '#707070', categories: [
        { id: 'gris-ab', label: 'Gris AB', cat: 'Catégorie 1', pct: 35 },
        { id: 'gris-b', label: 'Gris B', cat: 'Catégorie 2', pct: 55 },
        { id: 'gris-c', label: 'Gris C', cat: 'Catégorie 3', pct: 85 }
      ]},
      { id: 'gris-vert', label: 'Gris vert', hex: '#5A6B50', categories: [
        { id: 'gris-vert-ab', label: 'Gris-vert AB', cat: 'Catégorie 1', pct: 35 },
        { id: 'gris-vert-b', label: 'Gris-vert B', cat: 'Catégorie 2', pct: 55 },
        { id: 'gris-vert-c', label: 'Gris-vert C', cat: 'Catégorie 4', pct: 92 }
      ]}
    ]
  },
  'degrade-classique': {
    label: 'Teinte dégradé classique',
    degrade: true,
    couleurs: [
      { id: 'brun', label: 'Brun', hex: '#6B3A2A', categories: [
        { id: 'brun-ab-d', label: 'Brun AB', cat: 'Catégorie 1/0', pct: 35, pctEnd: 0 },
        { id: 'brun-b-d', label: 'Brun B', cat: 'Catégorie 2/0', pct: 55, pctEnd: 0 },
        { id: 'brun-c-d', label: 'Brun C', cat: 'Catégorie 3/0', pct: 85, pctEnd: 0 }
      ]},
      { id: 'gris', label: 'Gris', hex: '#707070', categories: [
        { id: 'gris-ab-d', label: 'Gris AB', cat: 'Catégorie 1/0', pct: 35, pctEnd: 0 },
        { id: 'gris-b-d', label: 'Gris B', cat: 'Catégorie 2/0', pct: 55, pctEnd: 0 },
        { id: 'gris-c-d', label: 'Gris C', cat: 'Catégorie 3/0', pct: 85, pctEnd: 0 }
      ]},
      { id: 'gris-vert', label: 'Gris vert', hex: '#5A6B50', categories: [
        { id: 'gris-vert-ab-d', label: 'Gris-vert AB', cat: 'Catégorie 1/0', pct: 35, pctEnd: 0 },
        { id: 'gris-vert-b-d', label: 'Gris-vert B', cat: 'Catégorie 2/0', pct: 55, pctEnd: 0 },
        { id: 'gris-vert-c-d', label: 'Gris-vert C', cat: 'Catégorie 3/0', pct: 85, pctEnd: 0 }
      ]}
    ]
  },
  'uni-tendance': {
    label: 'Teinte unie tendance',
    couleurs: [
      { id: 'violet', label: 'Violet', hex: '#6B3A8A', categories: [
        { id: 'violet-ab', label: 'Violet AB', cat: 'Catégorie 1', pct: 35 },
        { id: 'violet-b', label: 'Violet B', cat: 'Catégorie 2', pct: 55 },
        { id: 'violet-c', label: 'Violet C', cat: 'Catégorie 2', pct: 92 }
      ]},
      { id: 'bleu', label: 'Bleu', hex: '#2A4A8A', categories: [
        { id: 'bleu-ab', label: 'Bleu AB', cat: 'Catégorie 1', pct: 35 },
        { id: 'bleu-b', label: 'Bleu B', cat: 'Catégorie 2', pct: 55 },
        { id: 'bleu-c', label: 'Bleu C', cat: 'Catégorie 3', pct: 75 }
      ]},
      { id: 'orange', label: 'Orange', hex: '#C05A20', categories: [
        { id: 'orange-ab', label: 'Orange AB', cat: 'Catégorie 1', pct: 25 },
        { id: 'orange-b', label: 'Orange B', cat: 'Catégorie 2', pct: 45 },
        { id: 'orange-c', label: 'Orange C', cat: 'Catégorie 2', pct: 65 }
      ]}
    ]
  },
  'degrade-tendance': {
    label: 'Teinte dégradé tendance',
    degrade: true,
    couleurs: [
      { id: 'violet', label: 'Violet', hex: '#6B3A8A', categories: [
        { id: 'violet-d', label: 'Violet D', cat: 'Catégorie 3/0', pct: 85, pctEnd: 0 },
        { id: 'violet-cool', label: 'Violet Cool', cat: 'Catégorie 3/0', pct: 85, pctEnd: 18 },
        { id: 'violet-medium', label: 'Violet Medium', cat: 'Catégorie 3/1', pct: 85, pctEnd: 35 }
      ]},
      { id: 'bleu', label: 'Bleu', hex: '#2A4A8A', categories: [
        { id: 'bleu-d', label: 'Bleu D', cat: 'Catégorie 3/0', pct: 85, pctEnd: 0 },
        { id: 'bleu-cool', label: 'Bleu Cool', cat: 'Catégorie 3/0', pct: 85, pctEnd: 18 },
        { id: 'bleu-medium', label: 'Bleu Medium', cat: 'Catégorie 3/1', pct: 85, pctEnd: 35 }
      ]},
      { id: 'orange', label: 'Orange', hex: '#C05A20', categories: [
        { id: 'orange-b-d', label: 'Orange B', cat: 'Catégorie 1/0', pct: 45, pctEnd: 0 },
        { id: 'orange-c-d', label: 'Orange C', cat: 'Catégorie 2/0', pct: 65, pctEnd: 0 },
        { id: 'orange-d-d', label: 'Orange D', cat: 'Catégorie 2/0', pct: 75, pctEnd: 0 }
      ]}
    ]
  }
};

// ============================================================
// ÉTAPE 2 — Type de verre
// ============================================================

function cfgStep2Next() {
  if (!CFG.typeVerre) return;
  renderAmincissement();
  showStep(3);
  document.getElementById('btn-step3-next').disabled = !CFG.amincissement;
}

function renderTypeVerre() {
  var list = document.getElementById('cfg-type-verre-list');
  if (!list) return;
  var types = ['transparent', 'solaire', 'adaptatif'];
  var isProgressif = CFG.verreType === 'progressif';

  var icons = {
    transparent: '<svg width="44" height="44" viewBox="0 0 44 44"><circle cx="22" cy="22" r="20" fill="white" stroke="#ccc" stroke-width="1.5"/></svg>',
    solaire: '<div style="position:relative;width:44px;height:44px"><svg width="44" height="44" viewBox="0 0 44 44"><circle cx="22" cy="22" r="20" fill="#3d2b1f"/></svg><div style="position:absolute;bottom:0;left:0;display:flex;gap:2px"><div style="width:10px;height:10px;border-radius:50%;background:#6B3A2A;border:1px solid #fff"></div><div style="width:10px;height:10px;border-radius:50%;background:#707070;border:1px solid #fff"></div><div style="width:10px;height:10px;border-radius:50%;background:#5A6B50;border:1px solid #fff"></div></div></div>',
    adaptatif: '<div style="position:relative;width:44px;height:44px"><svg width="44" height="44" viewBox="0 0 44 44"><defs><linearGradient id="gadapt" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#2a2a2a"/><stop offset="100%" stop-color="#e0e0e0"/></linearGradient></defs><circle cx="22" cy="22" r="20" fill="url(#gadapt)"/></svg><div style="position:absolute;bottom:0;left:0;display:flex;gap:2px"><div style="width:10px;height:10px;border-radius:50%;background:#e5e5e5;border:1px solid #ccc"></div><div style="width:10px;height:10px;border-radius:50%;background:#aaa;border:1px solid #ccc"></div><div style="width:10px;height:10px;border-radius:50%;background:#555;border:1px solid #ccc"></div><div style="width:10px;height:10px;border-radius:50%;background:#222;border:1px solid #ccc"></div></div></div>'
  };

  var html = '';
  types.forEach(function(type) {
    var t = TYPES_VERRE[type];
    var sel = CFG.typeVerre === type;
    var displayPrice = isProgressif ? t.priceProgressif : t.price;
    html += '<div class="cfg-option' + (sel ? ' selected' : '') + '" onclick="selectTypeVerre(\'' + type + '\')">';
    html += '<div class="cfg-option__img--placeholder">' + icons[type] + '</div>';
    html += '<div class="cfg-option__body"><div class="cfg-option__name">' + t.label + '</div><div class="cfg-option__sub">' + t.sub + '</div></div>';
    html += '<div class="cfg-option__price">' + displayPrice + '</div>';
    html += '</div>';
  });
  list.innerHTML = html;
}

function selectTypeVerre(type) {
  CFG.typeVerre = type;
  CFG.amincissement = null;
  CFG.options = {};
  renderTypeVerre();
  document.getElementById('btn-step2-next').disabled = false;
  updateRecap();
}

// ============================================================
// ÉTAPE 3 — Amincissement
// ============================================================

function cfgStep3Next() {
  if (!CFG.amincissement) return;
  renderOptions();
  showStep(4);
}

function renderAmincissement() {
  var list = document.getElementById('cfg-amincissement-list');
  if (!list) return;

  var icons = {
    '1.5': '<svg width="56" height="28" viewBox="0 0 56 28"><ellipse cx="28" cy="14" rx="26" ry="7" fill="#e8e8e8" stroke="#bbb" stroke-width="1"/><ellipse cx="28" cy="14" rx="26" ry="7" fill="none" stroke="#999" stroke-width="1.5"/></svg>',
    '1.6': '<svg width="56" height="28" viewBox="0 0 56 28"><ellipse cx="28" cy="14" rx="26" ry="5" fill="#e8e8e8" stroke="#bbb" stroke-width="1"/><line x1="2" y1="9" x2="2" y2="19" stroke="#5b9bd5" stroke-width="1.5" marker-end="url(#arr)"/><line x1="54" y1="9" x2="54" y2="19" stroke="#5b9bd5" stroke-width="1.5"/><ellipse cx="28" cy="14" rx="26" ry="5" fill="none" stroke="#999" stroke-width="1.5"/></svg>',
    '1.67': '<svg width="56" height="28" viewBox="0 0 56 28"><ellipse cx="28" cy="14" rx="26" ry="3" fill="#e8e8e8" stroke="#bbb" stroke-width="1"/><line x1="2" y1="11" x2="2" y2="17" stroke="#5b9bd5" stroke-width="1.5"/><line x1="54" y1="11" x2="54" y2="17" stroke="#5b9bd5" stroke-width="1.5"/><line x1="28" y1="4" x2="28" y2="11" stroke="#5b9bd5" stroke-width="1"/><line x1="28" y1="17" x2="28" y2="24" stroke="#5b9bd5" stroke-width="1"/><ellipse cx="28" cy="14" rx="26" ry="3" fill="none" stroke="#999" stroke-width="1.5"/></svg>'
  };

  var html = '';
  Object.keys(AMINCISSEMENTS).forEach(function(indice) {
    var a = AMINCISSEMENTS[indice];
    var sel = CFG.amincissement === indice;
    html += '<div class="cfg-option' + (sel ? ' selected' : '') + '" onclick="selectAmincissement(\'' + indice + '\')">';
    html += '<div class="cfg-option__img--placeholder" style="width:64px">' + icons[indice] + '</div>';
    html += '<div class="cfg-option__body"><div class="cfg-option__name">' + a.label + '</div><div class="cfg-option__sub">' + a.sub + '</div></div>';
    if (a.recommande) html += '<span class="cfg-option__badge">Recommandé</span>';
    html += '<div class="cfg-option__price">' + a.price + '</div>';
    html += '</div>';
  });
  list.innerHTML = html;
}

function selectAmincissement(indice) {
  CFG.amincissement = indice;
  CFG.options = {};
  renderAmincissement();
  document.getElementById('btn-step3-next').disabled = false;
  updateRecap();
}

// ============================================================
// ÉTAPE 4 — Options
// ============================================================

function cfgStep4Next() {
  updateRecap();
  renderRecapFull();
  showStep(5);
}

function getOptionsForContext() {
  var vt = (CFG.correctionType === 'none') ? 'unifocal' : (CFG.verreType || 'unifocal');
  var tv = CFG.typeVerre;
  var am = CFG.amincissement;
  var is67 = am === '1.67';

  var antiReflet = { id: 'anti-reflet', label: 'Verres anti-reflet haut de gamme', sub: 'Traitement anti-reflet', price: '+20,00 €', multi: true, type: 'simple' };
  var antiLumiere = { id: 'anti-lumiere', label: 'Verres anti-lumière bleue', sub: 'Traitement anti-lumière bleue pour les écrans', price: '+25,00 €', multi: true, type: 'simple' };

  var progressifSubFull = [
    { id: 'classique', label: 'Classique', sub: '', price: 'Inclus' },
    { id: 'evolue', label: 'Évolué', sub: 'Champ de vision plus large', price: '+249,00 €' },
    { id: 'luxe', label: 'Luxe', sub: 'Adaptation optimale, vision de près plus optimisée', price: '+499,00 €' }
  ];

  var progressifOpt = { id: 'progressif', label: 'Type de verre progressif', sub: 'Choisissez votre niveau', price: null, multi: true, type: 'suboption', suboptions: progressifSubFull };

  var transitionOpt = { id: 'transition', label: 'Transition — fonçant en fonction des UV', sub: 'Choisissez parmi différentes couleurs lumineuses', price: 'Inclus', multi: false, type: 'transition',
    couleurs: [{ id: 'trans-brun', label: 'Brun', hex: '#6B3A2A' }, { id: 'trans-gris', label: 'Gris', hex: '#707070' }]
  };
  var xtractiveOpt = { id: 'xtractive', label: 'Xtractive — fonçant en fonction de la luminosité', sub: 'Choisissez parmi différentes couleurs lumineuses', price: '+30,00 €', multi: false, type: 'transition',
    couleurs: [{ id: 'xtr-brun', label: 'Brun', hex: '#6B3A2A' }, { id: 'xtr-gris', label: 'Gris', hex: '#707070' }]
  };
  var polarisantOpt = { id: 'polarisant', label: 'Polarisant', sub: 'Verres polarisants — Protection totale contre les rayons UV', price: '+50,00 €', multi: false, type: 'couleur-simple',
    couleurs: [{ id: 'pol-brun', label: 'Brun', hex: '#6B3A2A' }, { id: 'pol-gris', label: 'Gris', hex: '#707070' }, { id: 'pol-gris-vert', label: 'Gris vert', hex: '#5A6B50' }]
  };
  var miroirOpt = { id: 'miroir', label: 'Miroir', sub: 'Verres miroir avec teinte unie ou dégradée', price: '+40,00 €', multi: false, type: 'miroir' };

  var teinteOpt = function(cats) {
    return { id: 'teinte', label: 'Teinte', sub: 'Choisissez votre teinte', price: null, multi: false, type: 'teinte', categories: cats };
  };

  // UNIFOCAL / PAS DE CORRECTION
  if (vt === 'unifocal') {
    if (tv === 'transparent') return [antiReflet, antiLumiere];
    if (tv === 'solaire') {
      var cats = is67 ? ['uni-classique'] : ['uni-classique', 'degrade-classique', 'uni-tendance', 'degrade-tendance', 'surmesure'];
      var opts = [antiReflet, teinteOpt(cats)];
      if (!is67) opts.push(miroirOpt);
      opts.push(polarisantOpt);
      return opts;
    }
    if (tv === 'adaptatif') {
      return [antiReflet, transitionOpt, xtractiveOpt];
    }
  }

  // PROGRESSIF
  if (vt === 'progressif') {
    if (tv === 'transparent') return [antiReflet, antiLumiere, progressifOpt];
    if (tv === 'solaire') {
      var cats = is67 ? ['uni-classique'] : ['uni-classique', 'degrade-classique'];
      var opts = [antiReflet, progressifOpt, teinteOpt(cats)];
      if (!is67) opts.push(miroirOpt);
      opts.push(polarisantOpt);
      return opts;
    }
    if (tv === 'adaptatif') {
      if (is67) {
        return [antiReflet, progressifOpt, transitionOpt, xtractiveOpt];
      } else {
        return [antiReflet, progressifOpt, transitionOpt];
      }
    }
  }

  return [antiReflet];
}

function renderOptions() {
  var list = document.getElementById('cfg-options-list');
  if (!list) return;
  var opts = getOptionsForContext();
  var html = '';

  opts.forEach(function(opt, idx) {
    var isSelected = !!CFG.options[opt.id];
    html += '<div class="cfg-option-wrap">';
    html += '<div class="cfg-option' + (isSelected ? ' selected' : '') + '" onclick="toggleOptionNew(' + idx + ')">';
    html += '<div class="cfg-option__img--placeholder">' + getOptIcon(opt) + '</div>';
    html += '<div class="cfg-option__body"><div class="cfg-option__name">' + opt.label + '</div>';
    if (opt.sub) html += '<div class="cfg-option__sub">' + opt.sub + '</div>';
    html += '</div>';
    if (opt.price) html += '<div class="cfg-option__price">' + opt.price + '</div>';
    html += '</div>';

    if (isSelected) {
      if (opt.type === 'suboption') html += renderSuboptions(opt);
      else if (opt.type === 'teinte') html += renderTeintePanel(opt);
      else if (opt.type === 'miroir') html += renderMiroirPanel(opt);
      else if (opt.type === 'couleur-simple') html += renderCouleurSimplePanel(opt);
      else if (opt.type === 'transition') html += renderTransitionPanel(opt);
    }
    html += '</div>';
  });
  list.innerHTML = html;
  window._currentOpts = opts;
}

function getOptIcon(opt) {
  if (opt.id === 'anti-reflet') {
    return '<svg width="44" height="44" viewBox="0 0 44 44"><defs><clipPath id="cr1"><circle cx="22" cy="22" r="20"/></clipPath></defs><circle cx="22" cy="22" r="20" fill="#f0f0f0" stroke="#ddd" stroke-width="1"/><line x1="22" y1="2" x2="22" y2="42" stroke="#fff" stroke-width="1"/><circle cx="12" cy="22" r="9" fill="white" stroke="#ccc" stroke-width="1"/><circle cx="32" cy="22" r="9" fill="#f8f8f8" stroke="#ddd" stroke-width="1"/><line x1="4" y1="16" x2="9" y2="21" stroke="#a0c0e8" stroke-width="1" opacity="0.8"/><line x1="5" y1="13" x2="10" y2="18" stroke="#a0c0e8" stroke-width="1" opacity="0.5"/><line x1="3" y1="19" x2="7" y2="23" stroke="#a0c0e8" stroke-width="1" opacity="0.3"/></svg>';
  }
  if (opt.id === 'anti-lumiere') {
    return '<svg width="44" height="44" viewBox="0 0 44 44"><circle cx="22" cy="22" r="20" fill="#eef3ff" stroke="#c0d0ff" stroke-width="1"/><circle cx="14" cy="22" r="9" fill="#dde8ff" stroke="#99aaff" stroke-width="1"/><circle cx="30" cy="22" r="9" fill="#dde8ff" stroke="#99aaff" stroke-width="1"/><circle cx="14" cy="22" r="3" fill="#99aaff" opacity="0.7"/><circle cx="30" cy="22" r="3" fill="#99aaff" opacity="0.7"/></svg>';
  }
  if (opt.id === 'progressif') {
    return '<svg width="44" height="44" viewBox="0 0 44 44"><circle cx="22" cy="22" r="20" fill="#f8f8f8" stroke="#ddd" stroke-width="1"/><text x="22" y="18" text-anchor="middle" font-size="7" fill="#888" font-family="sans-serif">VL</text><line x1="10" y1="22" x2="34" y2="22" stroke="#ccc" stroke-width="0.8" stroke-dasharray="2,2"/><text x="22" y="31" text-anchor="middle" font-size="7" fill="#555" font-family="sans-serif">VP</text></svg>';
  }
  if (opt.id === 'teinte') {
    var hex = '#8B5E3C';
    var alpha = 0.55;
    var selectedCouleur = CFG.options['teinte-couleur'];
    var selectedType = CFG.options['teinte-type-id'];
    if (selectedCouleur && selectedType && TEINTES_DATA[selectedType]) {
      var c = TEINTES_DATA[selectedType].couleurs.find(function(x) { return x.id === selectedCouleur; });
      if (c) {
        hex = c.hex;
        var catId = CFG.options['teinte-cat-id'];
        if (catId) {
          var catObj = c.categories.find(function(x) { return x.id === catId; });
          if (catObj) alpha = catObj.pct / 100;
        }
      }
    }
    return '<svg width="44" height="44" viewBox="0 0 44 44"><circle cx="22" cy="22" r="20" fill="' + hex + '" fill-opacity="' + alpha + '" stroke="#ccc" stroke-width="1"/></svg>';
  }
  if (opt.id === 'miroir') {
    var m = CFG.options['miroir-couleur'];
    var mc = m ? MIROIR_COULEURS.find(function(x) { return x.id === m; }) : null;
    if (mc) {
      return '<svg width="44" height="44" viewBox="0 0 44 44"><defs><linearGradient id="gmir" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="' + mc.g1 + '"/><stop offset="100%" stop-color="' + mc.g2 + '"/></linearGradient></defs><circle cx="22" cy="22" r="20" fill="url(#gmir)" stroke="#ccc" stroke-width="1"/></svg>';
    }
    return '<svg width="44" height="44" viewBox="0 0 44 44"><circle cx="22" cy="22" r="20" fill="#e0e0e0" stroke="#ccc" stroke-width="1"/></svg>';
  }
  if (opt.id === 'polarisant') {
    var p = CFG.options['polarisant-couleur'];
    var colors = [{id:'pol-brun',hex:'#6B3A2A'},{id:'pol-gris',hex:'#707070'},{id:'pol-gris-vert',hex:'#5A6B50'}];
    var selC = p ? colors.find(function(c) { return c.id === p; }) : null;
    var fill = selC ? selC.hex : '#707070';
    return '<svg width="44" height="44" viewBox="0 0 44 44"><circle cx="22" cy="22" r="20" fill="' + fill + '" fill-opacity="0.7" stroke="#ccc" stroke-width="1"/></svg>';
  }
  if (opt.id === 'transition' || opt.id === 'xtractive') {
    var selColor = CFG.options[opt.id + '-couleur'];
    var tColors = [{id:'trans-brun',hex:'#6B3A2A'},{id:'trans-gris',hex:'#707070'},{id:'xtr-brun',hex:'#6B3A2A'},{id:'xtr-gris',hex:'#707070'}];
    var tSel = selColor ? tColors.find(function(c) { return c.id === selColor; }) : null;
    var tFill = tSel ? tSel.hex : '#707070';
    return '<svg width="44" height="44" viewBox="0 0 44 44"><defs><linearGradient id="gtr_' + opt.id + '" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="' + tFill + '" stop-opacity="0.9"/><stop offset="100%" stop-color="' + tFill + '" stop-opacity="0.1"/></linearGradient></defs><circle cx="22" cy="22" r="20" fill="url(#gtr_' + opt.id + ')" stroke="#ccc" stroke-width="1"/></svg>';
  }
  return '<svg width="44" height="44" viewBox="0 0 44 44"><circle cx="22" cy="22" r="20" fill="#f5f5f5" stroke="#ddd" stroke-width="1"/></svg>';
}


function renderSuboptions(opt) {
  var html = '<div class="cfg-suboptions open">';
  opt.suboptions.forEach(function(s) {
    var sel = CFG.options[opt.id + '-sub'] === s.id;
    html += '<div class="cfg-suboption' + (sel ? ' selected' : '') + '" onclick="selectSubOpt(\'' + opt.id + '\',\'' + s.id + '\')">';
    html += '<div class="cfg-suboption__name">' + s.label;
    if (s.sub) html += '<br><span style="font-size:10px;color:#888">' + s.sub + '</span>';
    html += '</div><div class="cfg-suboption__price">' + s.price + '</div></div>';
  });
  html += '</div>';
  return html;
}

function renderTeintePanel(opt) {
  var categories = opt.categories;
  var selectedType = CFG.options['teinte-type-id'];
  var selectedCouleur = CFG.options['teinte-couleur'];
  var selectedCat = CFG.options['teinte-cat-id'];

  var html = '<div style="border:1px solid #e5e5e5;border-top:none;background:#fafafa;padding:16px 18px 16px 48px">';

  html += '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:14px">';
  categories.forEach(function(catId) {
    var isSel = selectedType === catId;
    var label = catId === 'surmesure' ? 'Sur-mesure' : (TEINTES_DATA[catId] ? TEINTES_DATA[catId].label : catId);
    html += '<div style="padding:7px 13px;border:' + (isSel ? '1.5px solid #111;color:#111;font-weight:600' : '1px solid #ddd;color:#888') + ';font-size:11px;background:#fff;cursor:pointer" onclick="selectTeinteType(\'' + catId + '\')">' + label + '</div>';
  });
  html += '</div>';

  if (selectedType === 'surmesure') {
    html += '<div style="padding:14px;background:#fff;border:1px dashed #ddd;font-size:12px;color:#666;line-height:1.6">Notre équipe vous contactera pour définir votre teinte personnalisée.</div>';
  } else if (selectedType && TEINTES_DATA[selectedType]) {
    var tData = TEINTES_DATA[selectedType];

    html += '<div style="font-size:11px;color:#888;margin-bottom:10px;letter-spacing:.04em">Choisissez votre couleur :</div>';
    html += '<div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:14px">';
    tData.couleurs.forEach(function(c) {
      var isSel = selectedCouleur === c.id;
      html += '<div style="display:flex;align-items:center;gap:7px;padding:6px 12px;border:' + (isSel ? '1.5px solid #111' : '1px solid #ddd') + ';background:#fff;cursor:pointer" onclick="selectTeinteCouleur(\'' + c.id + '\')">';
      html += '<div style="width:22px;height:22px;border-radius:50%;background:' + c.hex + ';flex-shrink:0"></div>';
      html += '<span style="font-size:12px;color:' + (isSel ? '#111;font-weight:600' : '#555') + '">' + c.label + '</span>';
      html += '</div>';
    });
    html += '</div>';

    if (selectedCouleur) {
      var couleurData = tData.couleurs.find(function(c) { return c.id === selectedCouleur; });
      if (couleurData) {
        html += '<div style="font-size:11px;color:#888;margin-bottom:10px;letter-spacing:.04em">Votre teinte :</div>';
        html += '<div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:10px">';
        couleurData.categories.forEach(function(cat) {
          var isSel = selectedCat === cat.id;
          var alpha = cat.pct / 100;
          var swatchBg;
          if (tData.degrade) {
            var endAlpha = typeof cat.pctEnd !== 'undefined' ? cat.pctEnd / 100 : 0;
            swatchBg = 'linear-gradient(to bottom,' + couleurData.hex + ' 0%,rgba(' + hexToRgb(couleurData.hex) + ',' + endAlpha + ') 100%)';
          } else {
            swatchBg = couleurData.hex;
          }
          html += '<div style="display:flex;flex-direction:column;align-items:center;gap:5px;padding:10px 14px;border:' + (isSel ? '1.5px solid #111' : '1px solid #ddd') + ';background:#fff;min-width:90px;cursor:pointer" onclick="selectTeinteCat(\'' + cat.id + '\')">';
          if (tData.degrade) {
            html += '<div style="width:36px;height:36px;border-radius:50%;background:' + swatchBg + '"></div>';
          } else {
            html += '<div style="width:36px;height:36px;border-radius:50%;background:' + swatchBg + ';opacity:' + alpha + '"></div>';
          }
          html += '<div style="font-size:11px;font-weight:600;color:#111;text-align:center">' + cat.label + '</div>';
          html += '<div style="font-size:10px;color:#999;text-align:center">' + cat.cat + ' (' + cat.pct + '%' + (typeof cat.pctEnd !== 'undefined' ? ' → ' + cat.pctEnd + '%' : '') + ')</div>';
          html += '</div>';
        });
        html += '</div>';
        html += '<div style="font-size:10px;color:#bbb;font-style:italic">* Teinte non contractuelle — Rendu susceptible de varier légèrement</div>';
      }
    }
  }
  html += '</div>';
  return html;
}


function renderMiroirPanel(opt) {
  var selected = CFG.options['miroir-couleur'];
  var html = '<div style="border:1px solid #e5e5e5;border-top:none;background:#fafafa;padding:16px 18px 16px 48px">';
  html += '<div style="display:flex;flex-wrap:wrap;gap:10px">';
  MIROIR_COULEURS.forEach(function(m) {
    var isSel = selected === m.id;
    html += '<div style="display:flex;align-items:center;gap:8px;padding:8px 12px;border:' + (isSel ? '1.5px solid #111' : '1px solid #ddd') + ';background:#fff;cursor:pointer;border-radius:0" onclick="selectMiroir(\'' + m.id + '\')">';
    html += '<div style="width:22px;height:22px;border-radius:50%;background:linear-gradient(135deg,' + m.g1 + ',' + m.g2 + ');flex-shrink:0"></div>';
    html += '<span style="font-size:12px;color:' + (isSel ? '#111;font-weight:600' : '#555') + '">' + m.label + '</span>';
    html += '</div>';
  });
  html += '</div></div>';
  return html;
}

function renderCouleurSimplePanel(opt) {
  var selected = CFG.options[opt.id + '-couleur'];
  var html = '<div style="border:1px solid #e5e5e5;border-top:none;background:#fafafa;padding:16px 18px 16px 48px">';
  html += '<div style="font-size:11px;color:#888;margin-bottom:10px">Choisissez votre couleur :</div>';
  html += '<div style="display:flex;gap:10px;flex-wrap:wrap">';
  opt.couleurs.forEach(function(c) {
    var isSel = selected === c.id;
    html += '<div style="display:flex;align-items:center;gap:8px;padding:8px 14px;border:' + (isSel ? '1.5px solid #111' : '1px solid #ddd') + ';background:#fff;cursor:pointer" onclick="selectCouleurSimple(\'' + opt.id + '\',\'' + c.id + '\')">';
    html += '<div style="width:22px;height:22px;border-radius:50%;background:' + c.hex + ';flex-shrink:0"></div>';
    html += '<span style="font-size:12px;color:' + (isSel ? '#111;font-weight:600' : '#333') + '">' + c.label + '</span>';
    html += '</div>';
  });
  html += '</div></div>';
  return html;
}

function renderTransitionPanel(opt) {
  var selected = CFG.options[opt.id + '-couleur'];
  var html = '<div style="border:1px solid #e5e5e5;border-top:none;background:#fafafa;padding:16px 18px 16px 48px">';
  html += '<div style="font-size:11px;color:#888;margin-bottom:10px;letter-spacing:.04em">Choisissez votre couleur :</div>';
  html += '<div style="display:flex;gap:10px;flex-wrap:wrap">';
  opt.couleurs.forEach(function(c) {
    var isSel = selected === c.id;
    html += '<div style="display:flex;align-items:center;gap:8px;padding:8px 14px;border:' + (isSel ? '1.5px solid #111' : '1px solid #ddd') + ';background:#fff;cursor:pointer" onclick="selectCouleurSimple(\'' + opt.id + '\',\'' + c.id + '\')">';
    html += '<div style="width:24px;height:24px;border-radius:50%;background:linear-gradient(to bottom,' + c.hex + ' 0%,' + c.hex + '22 100%)"></div>';
    html += '<span style="font-size:12px;color:' + (isSel ? '#111;font-weight:600' : '#333') + '">' + c.label + '</span>';
    html += '</div>';
  });
  html += '</div></div>';
  return html;
}

function hexToRgb(hex) {
  var r = parseInt(hex.slice(1,3),16);
  var g = parseInt(hex.slice(3,5),16);
  var b = parseInt(hex.slice(5,7),16);
  return r + ',' + g + ',' + b;
}

// Actions
function toggleOptionNew(idx) {
  var opts = window._currentOpts || [];
  var opt = opts[idx];
  if (!opt) return;
  var id = opt.id;
  var isMulti = !!opt.multi;

  if (isMulti) {
    CFG.options[id] = !CFG.options[id];
  } else {
    var wasSelected = !!CFG.options[id];
    if (!wasSelected) {
      var nonMulti = ['teinte','miroir','polarisant','transition','xtractive','progressif'];
      nonMulti.forEach(function(k) {
        if (k !== id) {
          CFG.options[k] = false;
          delete CFG.options[k + '-couleur'];
          delete CFG.options[k + '-sub'];
        }
      });
      delete CFG.options['teinte-type-id'];
      delete CFG.options['teinte-couleur'];
      delete CFG.options['teinte-cat-id'];
      delete CFG.options['miroir-couleur'];
    }
    CFG.options[id] = !wasSelected;
    if (!CFG.options[id]) {
      delete CFG.options[id + '-couleur'];
      delete CFG.options[id + '-sub'];
      if (id === 'teinte') {
        delete CFG.options['teinte-type-id'];
        delete CFG.options['teinte-couleur'];
        delete CFG.options['teinte-cat-id'];
      }
      if (id === 'miroir') delete CFG.options['miroir-couleur'];
    }
  }
  renderOptions();
  updateRecap();
}

function selectSubOpt(parentId, subId) {
  CFG.options[parentId] = true;
  CFG.options[parentId + '-sub'] = subId;
  renderOptions();
  updateRecap();
}

function selectTeinteType(typeId) {
  CFG.options['teinte'] = true;
  CFG.options['teinte-type-id'] = typeId;
  delete CFG.options['teinte-couleur'];
  delete CFG.options['teinte-cat-id'];
  renderOptions();
  updateRecap();
}

function selectTeinteCouleur(couleurId) {
  CFG.options['teinte-couleur'] = couleurId;
  delete CFG.options['teinte-cat-id'];
  renderOptions();
  updateRecap();
}

function selectTeinteCat(catId) {
  CFG.options['teinte-cat-id'] = catId;
  renderOptions();
  updateRecap();
}

function selectMiroir(couleurId) {
  CFG.options['miroir'] = true;
  CFG.options['miroir-couleur'] = couleurId;
  renderOptions();
  updateRecap();
}

function selectCouleurSimple(optId, couleurId) {
  CFG.options[optId] = true;
  CFG.options[optId + '-couleur'] = couleurId;
  renderOptions();
  updateRecap();
}

function renderRecapFull() {
  var list = document.getElementById('cfg-recap-full-list');
  var totalBar = document.getElementById('cfg-recap-total-bar');
  if (!list) return;

  var lines = [];
  var totalExtras = 0;
  var monturePriceEuros = (window.CFG_VARIANT_PRICE || 0) / 100;

  lines.push({ cat: 'Monture', detail: window.CFG_PRODUCT_TITLE || '', sub: '', price: monturePriceEuros.toFixed(2).replace('.', ',') + ' €', step: null });

  if (CFG.correctionType === 'none') {
    lines.push({ cat: 'Correction', detail: 'Sans correction', sub: '', price: 'Inclus', step: 1 });
  } else if (CFG.correctionType === 'manual') {
    var corrLabel = CFG.verreType === 'progressif' ? 'Verres progressifs' : 'Verres standards';
    var corrDetail = 'Sphère OD ' + (CFG.sphereOD||'0') + ' / OG ' + (CFG.sphereOG||'0');
    if (CFG.ecartOD && CFG.ecartOG) corrDetail += ' — Écart OD ' + CFG.ecartOD + 'mm / OG ' + CFG.ecartOG + 'mm';
    lines.push({ cat: 'Correction', detail: corrLabel, sub: corrDetail, price: '', step: 1 });
  } else if (CFG.correctionType === 'upload') {
    lines.push({ cat: 'Correction', detail: 'Ordonnance téléchargée', sub: 'DP : ' + (CFG.dpTotal||'—') + ' mm', price: '', step: 1 });
  }

  if (CFG.typeVerre && TYPES_VERRE[CFG.typeVerre]) {
    var tv = TYPES_VERRE[CFG.typeVerre];
    var tvPrice = CFG.verreType === 'progressif' ? tv.priceProgressif : tv.price;
    totalExtras += parsePriceNum(tvPrice);
    lines.push({ cat: 'Type de verre', detail: tv.label, sub: '', price: tvPrice, step: 2 });
  }

  if (CFG.amincissement && AMINCISSEMENTS[CFG.amincissement]) {
    var am = AMINCISSEMENTS[CFG.amincissement];
    totalExtras += parsePriceNum(am.price);
    lines.push({ cat: 'Amincissement', detail: am.label, sub: '', price: am.price, step: 3 });
  }

  var opts = getOptionsForContext();
  opts.forEach(function(opt) {
    if (!CFG.options[opt.id]) return;
    var detail = opt.label;
    var sub = '';
    var priceStr = opt.price || '';

    if (opt.type === 'suboption' && CFG.options[opt.id + '-sub']) {
      var subId = CFG.options[opt.id + '-sub'];
      var subObj = opt.suboptions ? opt.suboptions.find(function(s) { return s.id === subId; }) : null;
      if (subObj) { detail += ' — ' + subObj.label; priceStr = subObj.price; }
    }
    if (opt.type === 'teinte') {
      var typeId = CFG.options['teinte-type-id'];
      if (typeId === 'surmesure') { detail = 'Teinte personnalisée sur-mesure'; priceStr = '+35,00 €'; }
      else if (typeId && TEINTES_DATA[typeId]) {
        detail = TEINTES_DATA[typeId].label;
        if (CFG.options['teinte-couleur']) {
          var c = TEINTES_DATA[typeId].couleurs.find(function(x) { return x.id === CFG.options['teinte-couleur']; });
          if (c) sub = c.label;
        }
        if (CFG.options['teinte-cat-id']) {
          var allCats = [];
          TEINTES_DATA[typeId].couleurs.forEach(function(c) { allCats = allCats.concat(c.categories); });
          var catObj = allCats.find(function(x) { return x.id === CFG.options['teinte-cat-id']; });
          if (catObj) { sub += (sub ? ' — ' : '') + catObj.label; priceStr = catObj.price || priceStr; }
        }
        priceStr = priceStr || getTeintePrice(typeId);
      }
    }
    if (opt.type === 'miroir' && CFG.options['miroir-couleur']) {
      var mc = MIROIR_COULEURS.find(function(m) { return m.id === CFG.options['miroir-couleur']; });
      if (mc) sub = mc.label;
    }
    if ((opt.type === 'couleur-simple' || opt.type === 'transition') && CFG.options[opt.id + '-couleur']) {
      var cObj = opt.couleurs ? opt.couleurs.find(function(c) { return c.id === CFG.options[opt.id + '-couleur']; }) : null;
      if (cObj) sub = cObj.label;
    }

    totalExtras += parsePriceNum(priceStr);
    lines.push({ cat: 'Options', detail: detail, sub: sub, price: priceStr || 'Inclus', step: 4 });
  });

  var html = '';
  lines.forEach(function(line) {
    html += '<div class="cfg-recap-full-line">';
    html += '<div class="cfg-recap-full-line__left">';
    html += '<div class="cfg-recap-full-line__cat">' + line.cat + '</div>';
    html += '<div class="cfg-recap-full-line__detail">' + line.detail;
    if (line.sub) html += '<span>' + line.sub + '</span>';
    html += '</div></div>';
    html += '<div class="cfg-recap-full-line__right">';
    html += '<div class="cfg-recap-full-line__price">' + (line.price || '') + '</div>';
    if (line.step) html += '<button class="cfg-recap-modify" onclick="showStep(' + line.step + ')">Modifier</button>';
    html += '</div></div>';
  });
  list.innerHTML = html;

  var totalFinal = monturePriceEuros + totalExtras;
  window.CFG_EXTRAS_TOTAL = totalExtras;
  if (totalBar) {
    totalBar.innerHTML = '<span>Total TTC</span><span>' + totalFinal.toFixed(2).replace('.', ',') + ' €</span>';
  }
}

function getTeintePrice(typeId) {
  var prices = { 'uni-classique': 'Inclus', 'degrade-classique': '+20,00 €', 'uni-tendance': '+10,00 €', 'degrade-tendance': '+30,00 €', 'surmesure': '+35,00 €' };
  return prices[typeId] || '';
}

function parsePriceNum(priceStr) {
  if (!priceStr || priceStr === 'Inclus') return 0;
  var match = priceStr.replace(',', '.').match(/[\d.]+/);
  return match ? parseFloat(match[0]) : 0;
}

function formatPrice(num) {
  return (num / 100).toFixed(2).replace('.', ',') + ' €';
}

const SHOPIFY_LENS_VARIANTS = {
  base: {
    transparent: {
      unifocal: 44825568051283,
      progressif: 44825568084051
    },
    solaire: {
      unifocal: 44825568116819,
      progressif: 44825568149587
    },
    adaptatif: {
      unifocal: 44825568182355,
      progressif: 44825568215123
    }
  },
  amincissement: {
    '1.6': 44825568313427,
    '1.67': 44825568346195
  },
  traitements: {
    antiReflet: 44825576570963,
    antiLumiereBleue: 44825576636499
  },
  progressifUpgrade: {
    evolue: 44825576702035,
    luxe: 44825576734803
  },
  teinte: {
    'uni-classique': 44825576800339,
    'degrade-classique': 44825576833107,
    'uni-tendance': 44825576865875,
    'degrade-tendance': 44825576898643,
    surmesure: 44825576931411
  },
  options: {
    miroir: 44825577029715,
    polarisant: 44825577062483,
    xtractive: 44825577095251
  }
};

function getLensConfigProperties(note) {
  const props = {
    '_configuration_verres': note,
    '_lens_type': CFG.typeVerre || '',
    '_lens_correction_mode': CFG.correctionType || '',
    '_lens_design': CFG.verreType || '',
    '_lens_thinning': CFG.amincissement || ''
  };

  if (CFG.correctionType === 'manual') {
    props['_sphere_od'] = CFG.sphereOD || '';
    props['_sphere_og'] = CFG.sphereOG || '';
    props['_cylindre_od'] = CFG.cylindreOD || '';
    props['_cylindre_og'] = CFG.cylindreOG || '';
    props['_axe_od'] = CFG.axeOD || '';
    props['_axe_og'] = CFG.axeOG || '';
    props['_addition_od'] = CFG.additionOD || '';
    props['_addition_og'] = CFG.additionOG || '';
    props['_ecart_od'] = CFG.ecartOD || '';
    props['_ecart_og'] = CFG.ecartOG || '';
    props['_dp_total'] = CFG.dpTotal || '';
  }

  if (CFG.correctionType === 'upload') {
    props['_dp_total'] = document.getElementById('dp-total-upload')?.value || CFG.dpTotal || '';
    props['_ordonnance_upload'] = CFG.ordoFile ? CFG.ordoFile.name : '';
  }

  if (CFG.options['teinte-type-id']) props['_teinte_type'] = CFG.options['teinte-type-id'];
  if (CFG.options['teinte-couleur']) props['_teinte_couleur'] = CFG.options['teinte-couleur'];
  if (CFG.options['teinte-cat-id']) props['_teinte_categorie'] = CFG.options['teinte-cat-id'];
  if (CFG.options['miroir-couleur']) props['_miroir_couleur'] = CFG.options['miroir-couleur'];
  if (CFG.options['polarisant-couleur']) props['_polarisant_couleur'] = CFG.options['polarisant-couleur'];
  if (CFG.options['transition-couleur']) props['_transition_couleur'] = CFG.options['transition-couleur'];
  if (CFG.options['xtractive-couleur']) props['_xtractive_couleur'] = CFG.options['xtractive-couleur'];
  if (CFG.options['progressif-sub']) props['_progressif_gamme'] = CFG.options['progressif-sub'];

  return props;
}

function buildLensCartItems(note) {
  const items = [];
  const sharedProps = getLensConfigProperties(note);
  const design = CFG.verreType === 'progressif' ? 'progressif' : 'unifocal';

  if (CFG.typeVerre && SHOPIFY_LENS_VARIANTS.base[CFG.typeVerre]?.[design]) {
    items.push({
      id: SHOPIFY_LENS_VARIANTS.base[CFG.typeVerre][design],
      quantity: 1,
      properties: sharedProps
    });
  }

  if (CFG.amincissement === '1.6' || CFG.amincissement === '1.67') {
    items.push({
      id: SHOPIFY_LENS_VARIANTS.amincissement[CFG.amincissement],
      quantity: 1,
      properties: sharedProps
    });
  }

  if (CFG.options['anti-reflet']) {
    items.push({
      id: SHOPIFY_LENS_VARIANTS.traitements.antiReflet,
      quantity: 1,
      properties: sharedProps
    });
  }

  if (CFG.options['anti-lumiere']) {
    items.push({
      id: SHOPIFY_LENS_VARIANTS.traitements.antiLumiereBleue,
      quantity: 1,
      properties: sharedProps
    });
  }

  if (CFG.options['progressif'] && CFG.options['progressif-sub']) {
    const gamme = CFG.options['progressif-sub'];
    if (gamme === 'evolue' || gamme === 'luxe') {
      items.push({
        id: SHOPIFY_LENS_VARIANTS.progressifUpgrade[gamme],
        quantity: 1,
        properties: sharedProps
      });
    }
  }

  if (CFG.options['teinte'] && CFG.options['teinte-type-id']) {
    const teinteType = CFG.options['teinte-type-id'];
    if (SHOPIFY_LENS_VARIANTS.teinte[teinteType]) {
      items.push({
        id: SHOPIFY_LENS_VARIANTS.teinte[teinteType],
        quantity: 1,
        properties: sharedProps
      });
    }
  }

  if (CFG.options['miroir']) {
    items.push({
      id: SHOPIFY_LENS_VARIANTS.options.miroir,
      quantity: 1,
      properties: sharedProps
    });
  }

  if (CFG.options['polarisant']) {
    items.push({
      id: SHOPIFY_LENS_VARIANTS.options.polarisant,
      quantity: 1,
      properties: sharedProps
    });
  }

  if (CFG.options['xtractive']) {
    items.push({
      id: SHOPIFY_LENS_VARIANTS.options.xtractive,
      quantity: 1,
      properties: sharedProps
    });
  }

  return items;
}

function cfgAddToCart() {
  var btn = document.getElementById('btn-add-to-cart');
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Ajout en cours...';
  }

  var variantId = parseInt(window.CFG_VARIANT_ID, 10);
  if (!variantId || isNaN(variantId)) {
    alert('Erreur : impossible de récupérer la variante. Rechargez la page.');
    if (btn) {
      btn.disabled = false;
      btn.textContent = 'AJOUTER AU PANIER →';
    }
    return;
  }

  var note = buildCartNote();

  var items = [
    {
      id: variantId,
      quantity: 1
    }
  ].concat(buildLensCartItems(note));

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
    .then(function(r) {
      if (!r.ok) throw new Error('Erreur ' + r.status);
      return r.json();
    })
    .then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note })
      });
    })
    .then(function() {
      window.location.href = '/cart';
    })
    .catch(function(err) {
      console.error(err);
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'AJOUTER AU PANIER →';
      }
      alert('Une erreur est survenue. Veuillez réessayer.');
    });
}



function buildCartNote() {
  var lines = [];
  var product = window.CFG_PRODUCT_TITLE || '';
  lines.push('=== CONFIGURATION VERRES ===');
  lines.push('Monture : ' + product);
  lines.push('');

  if (CFG.correctionType === 'none') {
    lines.push('Correction : Sans correction');
  } else if (CFG.correctionType === 'manual') {
    lines.push('Correction : ' + (CFG.verreType === 'progressif' ? 'Progressifs' : 'Unifocaux'));
    lines.push('  Sphère OD : ' + (CFG.sphereOD||'0') + ' / OG : ' + (CFG.sphereOG||'0'));
    lines.push('  Cylindre OD : ' + (CFG.cylindreOD||'0') + ' / OG : ' + (CFG.cylindreOG||'0'));
    lines.push('  Axe OD : ' + (CFG.axeOD||'0°') + ' / OG : ' + (CFG.axeOG||'0°'));
    if (CFG.additionOD) lines.push('  Addition OD : ' + CFG.additionOD + ' / OG : ' + (CFG.additionOG||''));
    lines.push('  Écart pupillaire OD : ' + (CFG.ecartOD||'—') + 'mm / OG : ' + (CFG.ecartOG||'—') + 'mm');
    lines.push('  DP totale : ' + (CFG.dpTotal||'—') + 'mm');
  } else if (CFG.correctionType === 'upload') {
    lines.push('Correction : Ordonnance téléchargée');
    lines.push('  DP totale : ' + (CFG.dpTotal||'—') + 'mm');
  }

  if (CFG.typeVerre && TYPES_VERRE[CFG.typeVerre]) {
    lines.push('Type de verre : ' + TYPES_VERRE[CFG.typeVerre].label);
  }
  if (CFG.amincissement && AMINCISSEMENTS[CFG.amincissement]) {
    lines.push('Amincissement : ' + AMINCISSEMENTS[CFG.amincissement].label);
  }

  var opts = getOptionsForContext();
  var optLines = [];
  opts.forEach(function(opt) {
    if (!CFG.options[opt.id]) return;
    var detail = opt.label;
    if (opt.type === 'suboption' && CFG.options[opt.id + '-sub']) {
      var subId = CFG.options[opt.id + '-sub'];
      var subObj = opt.suboptions ? opt.suboptions.find(function(s) { return s.id === subId; }) : null;
      if (subObj) detail += ' — ' + subObj.label;
    }
    if (opt.type === 'teinte') {
      var typeId = CFG.options['teinte-type-id'];
      if (typeId === 'surmesure') { detail = 'Teinte personnalisée sur-mesure'; }
      else if (typeId && TEINTES_DATA[typeId]) {
        detail = TEINTES_DATA[typeId].label;
        if (CFG.options['teinte-couleur']) detail += ' — ' + CFG.options['teinte-couleur'];
        if (CFG.options['teinte-cat-id']) detail += ' (' + CFG.options['teinte-cat-id'] + ')';
      }
    }
    if (opt.type === 'miroir' && CFG.options['miroir-couleur']) {
      detail += ' — ' + CFG.options['miroir-couleur'];
    }
    if ((opt.type === 'couleur-simple' || opt.type === 'transition') && CFG.options[opt.id + '-couleur']) {
      detail += ' — ' + CFG.options[opt.id + '-couleur'];
    }
    optLines.push('  - ' + detail);
  });
  if (optLines.length) { lines.push('Options :'); lines = lines.concat(optLines); }
  lines.push('');
  lines.push('===========================');
  return lines.join('\n');
}